import fetchData from '../fetcher'
import { useMutation } from "@tanstack/react-query"

interface RevokeSessionParams {
    sessionId: string
}

const revokeSession = async ({ sessionId }: RevokeSessionParams) => {
    return fetchData(`/iam/v4/security/sessions/${sessionId}/revoke`, { method: "POST" })
}

export const useSessionRevoke = () => {
    return useMutation({
        mutationKey: ["session-revoke"],
        mutationFn: ({ sessionId }: RevokeSessionParams) => revokeSession({ sessionId }),
    })
}